// interface StorageClient {
//   getItem(k: string): string | null;
//   setItem(k: string, v: string): void;
//   removeItem(k: string): void;
//   removeItem(k: string): void;
// }

// export const storageClientBuilder = (): StorageClient => {
//   const { localStorage } = window;
//   const getItem = (k: string): string | null => localStorage.getItem(k);
//   const setItem = (k: string, v: string) => localStorage.setItem(k, v);
//   const removeItem = (k: string) => localStorage.removeItem(k);

//   return {
//     getItem,
//     setItem,
//     removeItem,
//   };
// };

export const storageClient = window.localStorage;
